import { type MyLensesOrganization } from "../../gql-generated/types";
import { type OrganizationsList } from "../../shared/api/queries";

export const isCamkitEnabledInAnyOrg = (organizationsList: OrganizationsList): boolean =>
    organizationsList.some((organization: MyLensesOrganization) => organization.cameraKitEnabled);
